import SEOHead from "../components/shared/SEOHead.jsx";
import ResponsiveImage from "../components/shared/ResponsiveImage.jsx";

const SLOGAN = {
  de: "Ich glaube, das ist nicht der Schatz, den ihr sucht, Abenteurer.",
  en: "I don't think that's the treasure you're looking for, adventurer.",
};

// The only literal "page not found" statement anywhere on this page — the
// slogan below is whimsical flavor text, not a real error message, so a
// screen-reader user relies on this alt to know what page they're on.
const IMAGE_ALT = {
  de: "404 – Seite nicht gefunden",
  en: "404 – page not found",
};

export default function NotFound({ lang }) {
  return (
    <>
      <SEOHead lang={lang} path="/404" title="404" noindex />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "32px",
          padding: "72px 24px 112px",
          textAlign: "center",
        }}
      >
        <ResponsiveImage
          src="/assets/brand/404.png"
          alt={IMAGE_ALT[lang]}
          priority
          style={{ width: "100%", maxWidth: "900px", height: "auto" }}
        />
        <p
          style={{
            fontFamily: "var(--font-serif)",
            fontStyle: "italic",
            fontSize: "24px",
            lineHeight: 1.4,
            color: "var(--color-cream)",
            maxWidth: "46ch",
            margin: 0,
          }}
        >
          {SLOGAN[lang]}
        </p>
      </div>
    </>
  );
}
